<template>
  <sidepanel
    id="panel-edit-marker"
    title="Marker"
    :save="saveMarker"
    :processing="processing"
  >
    <div v-if="marker">
      <base-input v-model="marker.name" label="Name" />
      <div class="base-input">
        <label for="input-marker-unit">Unit</label>
        <select v-model="marker.unit" id="input-marker-unit">
          <option>Select...</option>
          <option
            v-for="(option, index) in units"
            :value="option"
            :key="'option-' + index"
            >{{ option }}</option
          >
        </select>
      </div>
      <base-input v-model="marker.type" label="Type" />
      <base-input v-model="marker.description" label="Description" />
      <label>Range threshold values</label>
      <div
        v-for="(markerRange, index) in marker.range"
        :key="'range-' + index"
        class="marker-range-item"
      >
        <Swatches v-model="markerRange.color" :colors="colors" />
        <input v-model="markerRange.title" />
        <input v-model.number="markerRange.value" type="number" />
        <button @click="removeRangeValue(index)">X</button>
      </div>
      <button
        @click="marker.range.push({ title: '', value: 0, color: '#eeeeee' })"
      >
        Add threshold
      </button>
    </div>
    <hr />
    <button @click="deleteMarker">Delete marker</button>
  </sidepanel>
</template>

<script>
import Swatches from "vue-swatches";
export default {
  data() {
    return {
      marker: null,
      processing: false,
      units: ["nmol/l", "mmol/L", "mg/dL", "mg/l", "pmol/L", "µmol/L", "µg/L"],
      colors: ["#F5DE91", "#68DE9F", "#DE9168", "#DE6868"]
    };
  },
  components: {
    Swatches
  },
  computed: {
    markerOriginal() {
      return this.$store.getters.sidepanel("panel-edit-marker")
        ? this.$store.getters.sidepanel("panel-edit-marker").payload
        : null;
    }
  },
  methods: {
    removeRangeValue(index) {
      this.marker.range.splice(index, 1);
    },
    async saveMarker() {
      this.processing = true;
      await this.$store.dispatch("KitsStore/saveMarker", this.marker);
      this.processing = false;
      this.removePanel();
    },
    deleteMarker() {
      if (!confirm("Delete this marker?")) return;
      this.$store.dispatch("KitsStore/deleteMarker", this.marker);
      this.removePanel();
    }
  },
  watch: {
    markerOriginal: {
      handler(to) {
        this.marker = JSON.parse(JSON.stringify(to));
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../styles/vars";

.marker-range-item {
  display: flex;
  width: 100%;
  justify-content: stretch;
  input {
    font: inherit;
    width: calc(50% - @h4);
  }
}
</style>
